import {Button} from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import {useTranslation} from "react-i18next";
import {useSupportContext} from "../../hooks/useSupportContext.ts";

/** Always visible while support works in a garage or group context, so nobody forgets where they save. */
const SupportContextBanner = () => {
    const {t} = useTranslation();
    const {context, leave} = useSupportContext();
    if (!context) return null;

    return (
        <div
            role="status"
            className="flex flex-wrap items-center gap-3 rounded-an-md px-4 py-2 mb-2 text-[#0E1529]"
            style={{background: "var(--an-yellow)"}}
        >
            <SupportAgentIcon fontSize="small"/>
            <div className="flex-1 min-w-0">
                <div className="font-bold">
                    {t("supportContext.banner", {type: t(`supportContext.${context.type}`), label: context.label})}
                </div>
                <div className="text-sm">{t("supportContext.bannerHint")}</div>
            </div>
            <Button
                variant="outlined"
                size="small"
                onClick={leave}
                // the banner stays yellow in both modes, so ink must not follow the theme's --an-ink
                sx={{
                    "&&.MuiButton-outlined": {color: "#0E1529", borderColor: "#0E1529"},
                    "&&.MuiButton-outlined:hover": {color: "#0E1529", borderColor: "#0E1529", backgroundColor: "rgba(14, 21, 41, 0.08)"},
                }}
            >
                {t("supportContext.end")}
            </Button>
        </div>
    );
};

export default SupportContextBanner;
